import React from 'react';
import { useTranslation } from 'react-i18next';
import { DebtAdjustmentVoucherStatus } from '@/types/debtAdjustmentVoucher';

interface DebtAdjustmentVoucherStatusBadgeProps {
  status: DebtAdjustmentVoucherStatus;
  className?: string;
}

const DebtAdjustmentVoucherStatusBadge: React.FC<DebtAdjustmentVoucherStatusBadgeProps> = ({
  status,
  className = ''
}) => {
  const { t } = useTranslation();

  const getStatusConfig = (status: DebtAdjustmentVoucherStatus) => {
    switch (status) {
      case 'created':
        return {
          label: t('debtAdjustmentVoucher.status.created'),
          className: 'bg-yellow-100 text-yellow-800'
        };
      case 'confirmed':
        return {
          label: t('debtAdjustmentVoucher.status.confirmed'),
          className: 'bg-green-100 text-green-800'
        };
      case 'cancelled':
        return {
          label: t('debtAdjustmentVoucher.status.cancelled'),
          className: 'bg-red-100 text-red-800'
        };
      default:
        return {
          label: status,
          className: 'bg-gray-100 text-gray-800'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
};

export default DebtAdjustmentVoucherStatusBadge;

